/**
 * Create Blog Post API
 *
 * Create new blog posts in Supabase.
 * @see src/features/blog/hooks/useCreateBlogPost.ts for React Query wrapper
 */

import { supabase } from '@/lib/supabase';
import type { BlogPost } from '../types';

/**
 * Create a new blog post
 * Automatically sets created_at and updated_at timestamps
 * @param data - Partial BlogPost data (id, created_at, updated_at will be set by database)
 * @returns Promise resolving to the created BlogPost object
 */
export const createBlogPost = async (data: Partial<BlogPost>): Promise<BlogPost> => {
  const { data: result, error } = await supabase
    .from('blog_posts')
    .insert([{
      ...data,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    }])
    .select()
    .single();

  if (error) throw error;
  return result;
};
